import { ReactComponent as Add } from '@basqet-dashboard/common/assets/icons/add.svg';
import { Button } from '@basqet-dashboard/common/components';
import { useCurrencies } from '@basqet-dashboard/common/hooks';
import { useFetchSettlementAccounts } from '@basqet-dashboard/common/hooks/queries';
import { AddSettlementAccountModal } from '@components';
import React, { useState } from 'react';

import { Account } from './account';
import { SettlementPreference } from './settlement-preference';

const SettlementSettings = () => {
  const [showModal, setShowModal] = useState(false);
  const { accounts, refetch } = useFetchSettlementAccounts();

  const { availableCurrencies } = useCurrencies();
  const handleNewAccount = () => {
    refetch();
    setShowModal(false);
  };

  return (
    <>
      <div className="card settlements">
        <h3 className="card__header">Settlement accounts</h3>
        <div className="settlements__list">
          {accounts &&
            accounts
              .sort((a, b) => b.default - a.default)
              .map((item) => (
                <Account
                  settlement={item}
                  key={item.id}
                  currencies={availableCurrencies}
                  onAccountChange={handleNewAccount}
                />
              ))}
        </div>
        <Button className="settlements__button" onClick={() => setShowModal(true)}>
          <Add />
          Add settlement account
        </Button>
      </div>

      <SettlementPreference />

      {showModal && <AddSettlementAccountModal onModalClose={handleNewAccount} />}
    </>
  );
};

export { SettlementSettings };
